<template>
    <div class="second_level">
        <comHeader />
        <!-- 主内容区域 -->
        <div class="main_content">
            <!-- 标题和介绍区域 -->
            <div class="hero_section" v-if="product_resources_data.header"
                :style="{ background: `url(${product_resources_data?.header?.banner}) no-repeat center center`, backgroundSize: 'cover' }">
                <p class="main_title" :style="{ color: product_resources_data?.header?.titlecolor }">
                    {{ product_resources_data?.header?.title }}</p>
                <p class="subtitle" :style="{ color: product_resources_data?.header?.subtitlecolor }">
                    {{ product_resources_data?.header?.subtitle }}</p>
                <div class="action_buttons">
                    <button class="btn_demo" @click="handleDemoClick">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                stroke="#344054" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M9.5 8.96533C9.5 8.48805 9.5 8.24941 9.59974 8.11618C9.68666 8.00007 9.81971 7.92744 9.96438 7.9171C10.1304 7.90525 10.3311 8.03429 10.7326 8.29239L15.4532 11.3271C15.8016 11.551 15.9758 11.663 16.0359 11.8054C16.0885 11.9298 16.0885 12.0702 16.0359 12.1946C15.9758 12.337 15.8016 12.449 15.4532 12.6729L10.7326 15.7076C10.3311 15.9657 10.1304 16.0948 9.96438 16.0829C9.81971 16.0726 9.68666 15.9999 9.59974 15.8838C9.5 15.7506 9.5 15.512 9.5 15.0347V8.96533Z"
                                stroke="#344054" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        观看演示
                    </button>
                    <button class="btn_try" :style="{ background: product_resources_data?.header?.buttoncolor }"
                        @click="handleClick">立即体验</button>
                </div>
                <!-- 视频预览区域 -->
                <div class="video_section">
                    <div class="video_player_container">
                        <video ref="videoRef" class="video_player" :src="product_resources_data?.video?.videolink"
                            poster="" preload="metadata" :controls="!showPlayBtn" @pause="onVideoPause"
                            @play="onVideoPlay" @click="togglePlay">
                            您的浏览器不支持 video 标签。
                        </video>
                        <template v-if="showPlayBtn">
                            <div class="custom_play_mask"></div>
                            <div class="custom_play_btn"
                                :style="{ background: product_resources_data?.video?.videobuttoncolor }"
                                @click="handlePlay">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path
                                        d="M21.0278 11.9998C21.0283 12.2356 20.9679 12.4675 20.8523 12.673C20.7367 12.8785 20.5699 13.0506 20.3681 13.1725L7.86111 20.8236C7.65025 20.9527 7.40874 21.0232 7.16153 21.0277C6.91431 21.0323 6.67036 20.9708 6.45486 20.8496C6.24141 20.7303 6.06361 20.5562 5.93973 20.3454C5.81584 20.1345 5.75036 19.8945 5.75 19.6499V4.3496C5.75036 4.10505 5.81584 3.86501 5.93973 3.65417C6.06361 3.44333 6.24141 3.26928 6.45486 3.14994C6.67036 3.02872 6.91431 2.96722 7.16153 2.9718C7.40874 2.97637 7.65025 3.04686 7.86111 3.17598L20.3681 10.827C20.5699 10.949 20.7367 11.1211 20.8523 11.3266C20.9679 11.5321 21.0283 11.764 21.0278 11.9998Z"
                                        fill="white" />
                                </svg>
                            </div>
                        </template>
                    </div>
                </div>
            </div>

            <div class="video_section_zhanwei">

            </div>

            <!-- Features 部分 -->
            <div class="features_section">
                <div class="features_header">
                    <span class="features_label"
                        :style="{ color: product_resources_data?.features?.entitlecolor }">{{ product_resources_data?.features?.entitle }}</span>
                    <h2 class="features_title">{{ product_resources_data?.features?.title }}</h2>
                </div>
                <div class="features_description">
                    <p>{{ product_resources_data?.features?.subtitle }}</p>
                </div>
            </div>

            <!-- 标题介绍 部分 -->
            <div class="title_introduction">
                <div class="title_introduction_item" v-for="(item, index) in product_resources_data?.introductions"
                    :key="index">
                    <div class="item_content">
                        <div class="item_icon">
                            <img :src="item.icon" alt="item.title" />
                        </div>
                        <h3 class="item_title">{{ item.title }}</h3>
                        <p class="item_description">
                            {{ item.subtitle }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- 新增左右结构区块渲染 -->
            <div class="feature_blocks">
                <div v-for="(block, idx) in product_resources_data?.Left_Right_introduction" :key="idx"
                    class="feature_block" :class="{ reverse: block.reverse }">
                    <div class="feature_block_content">
                        <div class="feature_block_subtitle" v-if="block.title">{{ block.title }}</div>
                        <div class="feature_block_title">{{ block.slogan }}</div>
                        <div class="feature_block_desc">{{ block.description }}</div>
                    </div>
                    <div class="feature_block_img">
                        <img :src="block.image" alt="block.title" />
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部信息区块 -->
        <footer class="footer_info">
            <div class="footer_main">
                <div class="footer_logo_row">
                    <!-- <img class="footer_logo" src="/logo_increscence.png" alt="盈科千信LOGO" /> -->
                    <div class="footer_company_name">
                        <img src="../assets/yklogo.png" alt="盈科千信LOGO" />
                    </div>
                    <button class="footer_backtop" @click="scrollToTop" title="回到顶部">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                            <path
                                d="M24.0915 13.984C23.8382 13.984 23.5849 13.8907 23.3849 13.6907L15.9982 6.30404L8.61154 13.6907C8.22487 14.0774 7.58487 14.0774 7.1982 13.6907C6.81154 13.304 6.81154 12.664 7.1982 12.2774L15.2915 4.18404C15.6782 3.79738 16.3182 3.79738 16.7049 4.18404L24.7982 12.2774C25.1849 12.664 25.1849 13.304 24.7982 13.6907C24.6115 13.8907 24.3449 13.984 24.0915 13.984Z"
                                fill="#292D32" />
                            <path
                                d="M16 28.5574C15.4533 28.5574 15 28.1041 15 27.5574V5.11743C15 4.57076 15.4533 4.11743 16 4.11743C16.5467 4.11743 17 4.57076 17 5.11743V27.5574C17 28.1041 16.5467 28.5574 16 28.5574Z"
                                fill="#292D32" />
                        </svg>
                    </button>
                </div>
                <div class="footer_line"></div>
                <div class="footer_text_info">
                    <div>北京盈科千信科技有限公司</div>
                    <div>地址：北京市海淀区中关村南大街48号</div>
                    <div>邮箱：<a href="mailto:PRODUCT@INCRESCENCE.NET">Product@Increscence.net</a></div>
                    <div class="footer_copyright">
                        Copyright © {{ new Date().getFullYear() }} &nbsp;
                        <!-- <img src="/beian_icon.png" alt="备案" style="height:16px;vertical-align:middle;" /> -->
                        京ICP备15054044号-1
                    </div>
                </div>
            </div>
        </footer>
    </div>

</template>

<script setup>
import { ref } from 'vue';
import comHeader from '../components/comHeader.vue'
import { useRouter } from 'vue-router';
import axios from 'axios';
import { ElMessage } from "element-plus";
import { getCookie } from '../utils/cookei';

const router = useRouter();
const keyValue = ref(0);

const product_resources_data = ref({});

const videoRef = ref(null);
const showPlayBtn = ref(true);

const handleDemoClick = () => {
    // 定位到视频预览区域 距离顶部100px
    const videoSection = document.querySelector('.btn_demo');
    if (videoSection) {
        videoSection.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
    handlePlay();
}

const getProductResources = async () => {
    const res = await axios.get(process.env.VUE_APP_LOGIN_URL + 'organ/product/resource/', {
        params: {
            product_id: 77
        }
    });
    product_resources_data.value = res.data.data;
}
getProductResources();
const handlePlay = () => {
    if (videoRef.value) {
        videoRef.value.play();
        showPlayBtn.value = false;
    }
};

function onVideoPause() {
    showPlayBtn.value = true;
}
function onVideoPlay() {
    showPlayBtn.value = false;
}

const handleClick = () => {
    if (!getCookie('Token')) {
        ElMessage.warning('请先登录账号');
        keyValue.value++;
        return;
    }
    router.push(product_resources_data.value?.header?.buttonlink);
}

function scrollToTop() {
    var top = document.querySelector('.second_level');
    if (top) {
        top.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
}

const togglePlay = () => {
    if (!videoRef.value) return;
    if (videoRef.value.paused) {
        videoRef.value.play();
        showPlayBtn.value = false;
    } else {
        videoRef.value.pause();
        showPlayBtn.value = true;
    }
};
</script>

<style scoped>
.innerspan {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.second_level {
    min-height: 100vh;
    width: 100%;
    min-width: 1200px;
    overflow: auto;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    background-color: #fff;
}

/* 主内容区域 */
.main_content {
    width: 100%;
    margin: 0 auto;
}

/* 标题区域 */
.hero_section {
    text-align: center;
    margin-bottom: 80px;
    aspect-ratio: 1920/800;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
}

.hero_section::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 47%;
    pointer-events: none;
    background: linear-gradient(0deg, #fff 0%, rgba(255,255,255,0.0) 100%);
    z-index: 2;
}

.main_title {
    font-size: 48px;
    font-weight: 700;
    color: white;
    margin-bottom: 24px;
    margin-top: 0;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.subtitle {
    font-size: 20px;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 48px;
}

.action_buttons {
    display: flex;
    gap: 16px;
    justify-content: center;
    align-items: center;
    margin-bottom: 108px;
    z-index: 3;
}

.btn_demo {
    padding: 16px 28px;
    background: rgba(255, 255, 255);
    border: 1px solid #D0D5DD;
    border-radius: 8px;
    color: white;
    font-weight: 600;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s;
    backdrop-filter: blur(10px);
    color: #344054;
    max-height: 52px;
}

.btn_demo:hover {
    background: rgba(255, 255, 255, 0.9);
}

.btn_try {
    padding: 16px 28px;
    background: #4285f4;
    border: none;
    border-radius: 8px;
    color: white;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s;
    font-size: 18px;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    max-height: 52px;
}

.btn_try:hover {
    background: #3367d6;
}

/* 视频区域 */
.video_section {
    margin-bottom: 120px;
    width: 1000px;
    height: 500px;
    margin: 0 auto;
    position: absolute;
    bottom: -350px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3;
}

.video_section_zhanwei {
    height: 400px;
}

.video_player_container {
    width: 1000px;
    height: 500px;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
    background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.video_player {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background: #000;
    border-radius: 16px;
    display: block;
}

.video_placeholder {
    background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
    height: 500px;
    width: 1000px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.video_overlay {
    text-align: center;
    color: white;
    position: relative;
    z-index: 2;
}

.play_button {
    width: 80px;
    height: 80px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 24px;
    cursor: pointer;
    transition: all 0.3s;
    backdrop-filter: blur(10px);
}

.play_button:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
}


.video_title {
    font-size: 36px;
    font-weight: 700;
    margin-bottom: 8px;
    background: linear-gradient(45deg, #00d4ff, #00ff88);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.video_subtitle {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 8px;
}

.video_description {
    font-size: 16px;
    margin-bottom: 32px;
    opacity: 0.9;
}

.feature_tags {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: center;
    max-width: 600px;
    margin: 0 auto;
}

.feature_tag {
    padding: 8px 16px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    font-size: 14px;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
}

/* Features 部分 */
.features_section {
    text-align: center;
}

.features_header {
    margin-bottom: 32px;
}

.features_label {
    display: inline-block;
    padding: 6px 16px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    /* color: rgba(255, 255, 255, 0.8); */
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 12px;
    backdrop-filter: blur(10px);
}

.features_title {
    font-size: 36px;
    font-weight: 700;
    /* color: white; */
    margin: 0;
    margin-bottom: 20px;
}

.features_description {
    max-width: 1018px;
    margin: 0 auto;
}

.features_description p {
    font-size: 20px;
    line-height: 1.6;
    color: #475467;
    margin: 0;
    margin-bottom: 200px;
}

/* 标题介绍部分 */
.title_introduction {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
    max-width: 1000px;
    margin: 0 auto;
    padding: 0;
}

.title_introduction_item {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    padding: 32px 0;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    transition: all 0.3s ease;
    cursor: pointer;
    /* margin-bottom: 64px; */
}

/* 
.title_introduction_item:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: translateY(-4px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
} */

.item_content {
    text-align: center;
}

.item_icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid #EAECF0;
    border-radius: 10px;
    margin-bottom: 20px;
    color: #4285f4;
    transition: all 0.3s ease;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.title_introduction_item:hover .item_icon {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
}

.item_title {
    font-size: 20px;
    font-weight: 600;
    color: #101828;
    margin: 0 0 16px 0;
    line-height: 1.4;
}

.item_description {
    font-size: 16px;
    line-height: 1.6;
    color: #475467;
    margin: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .main_title {
        font-size: 32px;
    }

    .subtitle {
        font-size: 18px;
    }

    .action_buttons {
        flex-direction: column;
        align-items: stretch;
    }

    .video_title {
        font-size: 24px;
    }

    .video_subtitle {
        font-size: 18px;
    }

    .feature_tags {
        max-width: 100%;
    }

    .features_title {
        font-size: 28px;
    }

    .nav_left {
        gap: 20px;
    }

    .nav_menu {
        display: none;
    }

    /* 移动端title_introduction适配 */
    .title_introduction {
        grid-template-columns: 1fr;
        gap: 20px;
        margin: 60px auto 0;
        padding: 0 16px;
    }

    .title_introduction_item {
        padding: 24px 20px;
    }

    .item_icon {
        width: 56px;
        height: 56px;
        margin-bottom: 16px;
    }

    .item_title {
        font-size: 18px;
        margin-bottom: 12px;
    }

    .item_description {
        font-size: 13px;
    }
}

/* 左右结构区块样式 */
.feature_blocks {
    width: 100%;
    max-width: 1200px;
    margin: 120px auto 0 auto;
    display: flex;
    flex-direction: column;
    gap: 80px;
}

.feature_block {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 48px;
    min-height: 380px;
    position: relative;
}

.feature_block.reverse {
    flex-direction: row-reverse;
}

.title_introduction_item:hover {
    transform: translateY(-8px) scale(1.035);
    box-shadow: 0 8px 32px rgba(0, 75, 255, 0.12), 0 1.5px 6px rgba(16, 24, 40, 0.08);
    background: rgba(0, 75, 255, 0.04);
}

.feature_block_content {
    flex: 1 1 0%;
    padding: 0 32px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
}

.feature_block_subtitle {
    color: #004BFF;
    font-family: "HarmonyOS Sans SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    /* 175% */
    margin-bottom: 16px;
}

.feature_block_title {
    color: #101828;
    font-family: Inter;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 38px;
    /* 126.667% */
    margin-bottom: 24px;
}

.feature_block_desc {
    color: #475467;
    /* Text lg/Regular */
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    /* 155.556% */
}

.feature_block_img {
    flex: 1 1 0%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 0;
}

.feature_block_img img {
    width: 100%;
    max-width: 480px;
    min-width: 320px;
    border-radius: 18px;
    box-shadow: 0 4px 32px 0 rgba(16, 24, 40, 0.10);
    border: 2px solid #EAECF0;
    background: #f4f6fa;
    object-fit: cover;
}

/* 图片占位符 */
.feature_block_img img[src=''] {
    background: #f4f6fa;
    border: 2px dashed #EAECF0;
    min-height: 260px;
    content: '';
}

@media (max-width: 900px) {
    .feature_blocks {
        gap: 40px;
        margin-top: 60px;
    }

    .feature_block {
        gap: 24px;
        min-height: 240px;
    }

    .feature_block_title {
        font-size: 24px;
    }

    .feature_block_desc {
        font-size: 15px;
    }

    .feature_block_img img {
        max-width: 320px;
        min-width: 180px;
    }
}

@media (max-width: 600px) {
    .feature_block {
        flex-direction: column !important;
        align-items: flex-start;
        gap: 16px;
        min-height: unset;
    }

    .feature_block_content {
        padding: 0 4px;
    }

    .feature_block_img {
        width: 100%;
        justify-content: flex-start;
    }

    .feature_block_img img {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        border-radius: 12px;
    }
}

.footer_info {
    width: 100%;
    background: #FAFAFA;
    border-top: 1px solid #F0F0F0;
    margin-top: 120px;
}

.footer_main {
    max-width: 1200px;
    margin: 0 auto;
    padding: 48px 24px 32px 24px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    min-height: 180px;
}

.footer_logo_row {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
}

.footer_line {
    width: 100%;
    height: 1px;
    background: #D6D7D9;
    margin-bottom: 24px;
}

.footer_company_name {
    font-size: 20px;
    font-weight: 600;
    color: #222;
    line-height: 1.2;
}

.footer_company_name img {
    width: 201px;
    height: 85.224px;
}

.footer_backtop {
    width: 48px;
    height: 48px;
    border: none;
    background: #fff;
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: box-shadow 0.2s;
    z-index: 2;
}

.footer_backtop:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.16);
    background: #f5f7fa;
}

.footer_text_info {
    color: var(---, #262729);
    font-family: "HarmonyOS Sans SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 42px;
    letter-spacing: 0.24px;
}

.footer_text_info a {
    color: #004BFF;
    text-decoration: none;
}

.footer_text_info a:hover {
    text-decoration: underline;
}

.footer_copyright {
    margin-top: 28px;
    font-size: 14px;
    color: #888;
}

@media (max-width: 900px) {
    .footer_main {
        padding: 32px 12px 24px 12px;
    }

    .footer_logo_row {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }

    .footer_backtop {
        align-self: flex-end;
        margin-top: 8px;
    }
}

.custom_play_mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.45);
    z-index: 1;
}

.custom_play_btn {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
    z-index: 2;
    transition: transform 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 54px;
    height: 54px;
    background: #004BFF;
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10);
}

.custom_play_btn:hover {
    transform: translate(-50%, -50%) scale(1.08);
}

.custom_play_btn svg {
    width: 24px;
    height: 24px;
}

.item_icon img{
    width: 24px;
    height: 24px;
}
</style>
